import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { UploaderBlock } from '../../abstract/UploaderBlock.js';
import { ActivityBlock } from '../../abstract/ActivityBlock.js';
import { createCdnUrl, createCdnUrlModifiers } from '../../utils/cdn-utils.js';
import { fileCssBg } from '../svg-backgrounds/svg-backgrounds.js';
import { fileIsImage } from '../../utils/fileTypes.js';
export class UploadDetails extends UploaderBlock {
  constructor() {
    super(...arguments);
    _defineProperty(this, "activityType", ActivityBlock.activities.DETAILS);
    _defineProperty(this, "pauseRender", true);
    _defineProperty(this, "init$", _objectSpread(_objectSpread({}, this.init$), {}, {
      checkerboard: false,
      fileSize: null,
      fileName: '',
      cdnUrl: '',
      errorTxt: '',
      cloudEditBtnHidden: true,
      onNameInput: null,
      onBack: () => {
        this.historyBack();
      },
      onRemove: () => {
        /** @type {File[]} */
        this.uploadCollection.remove(this.entry.uid);
        this.historyBack();
      },
      onCloudEdit: () => {
        if (this.entry.getValue('uuid')) {
          this.$['*currentActivity'] = ActivityBlock.activities.CLOUD_IMG_EDIT;
        }
      }
    }));
  }
  showNonImageThumb() {
    let color = window.getComputedStyle(this).getPropertyValue('--clr-generic-file-icon');
    let url = fileCssBg(color, 108, 108);
    this.ref.filePreview.setImageUrl(url);
    this.set$({
      checkerboard: false
    });
  }
  initCallback() {
    super.initCallback();
    // Rendering is postponed for the CSS-context-properties usage in template:
    this.render();
    this.$.fileSize = this.l10n('file-size-unknown');
    this.registerActivity(this.activityType, {
      onDeactivate: () => {
        this.ref.filePreview.clear();
      }
    });
    /** @type {import('../FilePreview/FilePreview.js').FilePreview} */
    this.sub('*focusedEntry', (/** @type {import('../../abstract/TypedData.js').TypedData} */entry) => {
      if (!entry) {
        return;
      }
      if (this._entrySubs) {
        this._entrySubs.forEach(sub => {
          this._entrySubs.delete(sub);
          sub.remove();
        });
      } else {
        /** @private */
        this._entrySubs = new Set();
      }
      this.entry = entry;
      /** @type {File} */
      let file = entry.getValue('file');
      if (file) {
        /**
         * @private
         * @type {File}
         */
        this._file = file;
        let isImage = fileIsImage(this._file);
        if (isImage && !entry.getValue('cdnUrl')) {
          this.ref.filePreview.setImageFile(this._file);
          this.set$({
            checkerboard: true
          });
        }
        if (!isImage) {
          this.showNonImageThumb();
        }
      }
      let tmpSub = (prop, callback) => {
        this._entrySubs.add(this.entry.subscribe(prop, callback));
      };
      tmpSub('fileName', name => {
        this.$.fileName = name;
        this.$.onNameInput = () => {
          let value = this.ref.file_name_input['value'];
          Object.defineProperty(this._file, 'name', {
            writable: true,
            value: value
          });
          this.entry.setValue('fileName', value);
        };
      });
      tmpSub('fileSize', size => {
        this.$.fileSize = Number.isFinite(size) ? this.fileSizeFmt(size) : this.l10n('file-size-unknown');
      });
      tmpSub('errors', errors => {
        var _errors$;
        this.$.errorTxt = (_errors$ = errors[0]) === null || _errors$ === void 0 ? void 0 : _errors$.message;
      });
      tmpSub('externalUrl', url => {
        if (!url) {
          return;
        }
        if (!this.entry.getValue('uuid')) {
          this.showNonImageThumb();
        }
      });
      tmpSub('cdnUrl', cdnUrl => {
        const canUseCloudEditor = this.cfg.useCloudImageEditor && cdnUrl && this.entry.getValue('isImage');
        cdnUrl && this.ref.filePreview.clear();
        this.set$({
          cdnUrl,
          cloudEditBtnHidden: !canUseCloudEditor
        });
        if (cdnUrl && this.entry.getValue('isImage')) {
          // TODO: need to resize image to fit the canvas size
          let imageUrl = createCdnUrl(cdnUrl, createCdnUrlModifiers('format/auto', 'preview'));
          this.ref.filePreview.setImageUrl(this.proxyUrl(imageUrl));
        }
      });
    });
  }
}
UploadDetails.template = /* HTML */"\n  <lr-activity-header>\n    <button type=\"button\" class=\"mini-btn\" set=\"onclick: *historyBack\">\n      <lr-icon name=\"back\"></lr-icon>\n    </button>\n    <span l10n=\"caption-edit-file\"></span>\n    <button type=\"button\" class=\"mini-btn close-btn\" set=\"onclick: *closeModal\">\n      <lr-icon name=\"close\"></lr-icon>\n    </button>\n  </lr-activity-header>\n  <div class=\"content\">\n    <lr-tabs tab-list=\"tab-view, tab-details\">\n      <div tab-ctx=\"tab-details\" class=\"details\">\n        <div class=\"info-block\">\n          <div class=\"info-block_name\" l10n=\"file-name\"></div>\n          <input\n            name=\"name-input\"\n            ref=\"file_name_input\"\n            set=\"value: fileName; oninput: onNameInput; @disabled: !!cdnUrl\"\n            type=\"text\"\n          />\n        </div>\n\n        <div class=\"info-block\">\n          <div class=\"info-block_name\" l10n=\"file-size\"></div>\n          <div>{{fileSize}}</div>\n        </div>\n\n        <div class=\"info-block\">\n          <div class=\"info-block_name\" l10n=\"cdn-url\"></div>\n          <a class=\"cdn-link\" target=\"_blank\" set=\"@href: cdnUrl; @disabled: !cdnUrl\">{{cdnUrl}}</a>\n        </div>\n\n        <div>{{errorTxt}}</div>\n      </div>\n\n      <lr-file-preview tab-ctx=\"tab-view\" set=\"@checkerboard: checkerboard;\" ref=\"filePreview\"> </lr-file-preview>\n    </lr-tabs>\n\n    <div class=\"toolbar\" set=\"@edit-disabled: cloudEditBtnHidden\">\n      <button type=\"button\" class=\"edit-btn secondary-btn\" set=\"onclick: onCloudEdit; @hidden: cloudEditBtnHidden;\">\n        <lr-icon name=\"edit\"></lr-icon>\n        <span l10n=\"edit-image\"></span>\n      </button>\n      <button type=\"button\" class=\"remove-btn secondary-btn\" set=\"onclick: onRemove\">\n        <lr-icon name=\"remove\"></lr-icon>\n        <span l10n=\"remove-from-list\"></span>\n      </button>\n      <div></div>\n      <button type=\"button\" class=\"back-btn primary-btn\" set=\"onclick: onBack\">\n        <span l10n=\"ok\"></span>\n      </button>\n    </div>\n  </div>\n";